import { useState, useEffect, useCallback, useMemo } from 'react';
import api from '../services/api';
import debounce from 'lodash.debounce';

export function usePacientes() {
    const [pacientes, setPacientes] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(25);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchPacientes = useCallback(async (searchTerm = '', currentPage = 0) => {
        setLoading(true);
        try {
            const query = `?page=${currentPage + 1}&limit=${rowsPerPage}&search=${encodeURIComponent(searchTerm)}&sort=-_id`;

            // 🚀 TRUCO UX: Forzamos 800ms de espera para que la animación se vea fluida
            const [res] = await Promise.all([
                api.get(`/pacientes${query}`),
                new Promise(resolve => setTimeout(resolve, 800)) // Retardo artificial de 0.8s
            ]);

            // Extracción a prueba de balas
            let listaPacientes = [];
            if (Array.isArray(res)) listaPacientes = res;
            else if (Array.isArray(res.data)) listaPacientes = res.data;
            else if (Array.isArray(res.docs)) listaPacientes = res.docs;
            else if (Array.isArray(res.results)) listaPacientes = res.results;
            else if (res.data && Array.isArray(res.data.docs)) listaPacientes = res.data.docs;

            const totalPacientes = res.totalDocs || res.total || res.count || (res.data && res.data.totalDocs) || listaPacientes.length;

            setPacientes(listaPacientes);
            setTotal(totalPacientes);

        } catch (error) {
            console.error("Error en sincronización de pacientes", error);
            setPacientes([]);
        } finally {
            setLoading(false);
        }
    }, [rowsPerPage]);

    const debouncedFetch = useMemo(() => {
        return debounce((val, p) => fetchPacientes(val, p), 400);
    }, [fetchPacientes]);

    useEffect(() => {
        debouncedFetch(search, page);
        return () => debouncedFetch.cancel();
    }, [search, page, debouncedFetch]);

    return {
        pacientes, total, page, setPage,
        search, setSearch, loading, recargar: () => fetchPacientes(search, page)
    };
}